import { useQuery } from '@tanstack/react-query';
import shallow from 'zustand/shallow';

import { getProductRecommendations } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';

export const PRODUCT_RECOMMENDATIONS_KEY = 'ProductRecommendations';

export const useProductRecommendations = (search_query: string) => {
  const session = useAuthStore();

  const [selectedShipToId] = useShipToStore(
    (s) => [s.selectedShipToId],
    shallow
  );

  return useQuery({
    queryKey: [
      PRODUCT_RECOMMENDATIONS_KEY,
      { search_query, warehouse: selectedShipToId },
    ],
    queryFn: () =>
      getProductRecommendations(session.access_token, {
        search_query: search_query.trim(),
        warehouse: selectedShipToId,
      }),
    enabled: search_query !== '',
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
